import angular from 'angular';
import uiRouter from 'angular-ui-router';
import selectFormElementComponent from './selectFormElement.component';

let selectFormElementModule = angular.module('selectFormElement', [
  uiRouter
])

.component('selectFormElement', selectFormElementComponent)

.name;

export default selectFormElementModule;
